import { render, staticRenderFns } from "./manyNFT.vue?vue&type=template&id=1b7c053c&scoped=true&"
import script from "./manyNFT.vue?vue&type=script&lang=js&"
export * from "./manyNFT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7c053c",
  null
  
)

export default component.exports